import BorderGradientContainer from './BorderGradientContainer'

export default BorderGradientContainer
